import { instance, GETREQUESTOPTIONS } from '../apiService';

interface GetAdminMetricsOptions {
    fullHistory?: boolean;
    departmentIds?: string[];
}

const getMetrics = async () => {
    const response = await instance.get('/api/metrics', GETREQUESTOPTIONS());
    return response.data;
};

const getAdminMetrics = async (options: GetAdminMetricsOptions = {}) => {
    const requestOptions = GETREQUESTOPTIONS();
    const params: Record<string, string> = {};

    if (options.fullHistory) {
        params.fullHistory = 'true';
    }

    if (options.departmentIds?.length) {
        params.departmentIds = options.departmentIds.join(',');
    }

    const response = await instance.get(
        '/api/metrics/admin',
        Object.keys(params).length > 0
            ? {
                  ...requestOptions,
                  params,
              }
            : requestOptions
    );
    return response.data;
};

const metricsService = {
    getMetrics,
    getAdminMetrics,
};

export default metricsService;
